module.exports = __webpack_public_path__ + "img/sc.bed218a4.svg";